{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/post-template",
	"title": "Post Template",
	"category": "theme",
	"ancestor": [ "core/query" ],
	"description": "Contains the block elements used to render a post, like the title, date, featured image, content or excerpt, and more.",
	"textdomain": "default",
	"usesContext": [
		"queryId",
		"query",
		"displayLayout",
		"templateSlug",
		"previewPostType",
		"enhancedPagination",
		"postType",
		"postId"
	],
	"supports": {
		"anchor": true,
		"reusable": false,
		"html": false,
		"align": [ "wide", "full" ],
		"layout": true,
		"background": {
			"backgroundImage": true,
			"backgroundSize": true,
			"gradient": true,
			"__experimentalDefaultControls": {
				"backgroundImage": true,
				"gradient": true
			}
		},
		"color": {
			"gradients": true,
			"link": true,
			"heading": true,
			"button": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"spacing": {
			"margin": true,
			"padding": true,
			"blockGap": {
				"__experimentalDefault": "1.25em"
			},
			"__experimentalDefaultControls": {
				"blockGap": true,
				"padding": false,
				"margin": false
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true
		},
		"shadow": true
	},
	"style": "wp-block-post-template",
	"editorStyle": "wp-block-post-template-editor"
}
